import * as React from 'react'

let selection: { teamId: string | null } | undefined

export function getDashboardRequestTeamId() {
  return selection?.teamId ?? null
}

export function useDashboardRequestTeamId(teamId: string | null) {
  // Query subscriptions fetch in passive effects, after this committed selection is available.
  React.useLayoutEffect(() => {
    const currentSelection = { teamId }
    selection = currentSelection
    return () => {
      if (selection === currentSelection) {
        selection = undefined
      }
    }
  }, [teamId])
}
